import {
  AfterViewChecked,
  AfterViewInit, ChangeDetectorRef,
  Component,
  ContentChildren,
  Input,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren
} from '@angular/core';
import {ExcProgbarData} from '../app-exc-progbar/app-exc-progbar.component';
import {ExcTranslation} from 'exc-core';
import {DatePipe, CurrencyPipe} from '@angular/common';
import {DefaultSettingsService, ExcCurrency} from '../default-settings-service.service';

@Component({
  selector: 'app-exc-indicator',
  templateUrl: './app-exc-indicator.component.html',
  providers: [ExcCurrency, DatePipe],
  styles: []
})
export class AppExcIndicatorComponent extends ExcTranslation implements OnInit, AfterViewChecked {

  private sum: number;
  private _data: ExcIndicatorData[] = [];
  private divWidth = 0;
  private spanWidth = 0;
  private _colors = [
    {f: 'rgba(32, 83, 148, 1)', b: 'rgba(32, 83, 148, 0.6)'},
    {f: 'rgba(250, 169, 51, 1)', b: 'rgba(250, 169, 51, 0.6)'},
    {f: 'rgba(3, 181, 56, 1)', b: 'rgba(3, 181, 56, 0.6)'},
    {f: 'rgba(88, 200, 224, 1)', b: 'rgba(88, 200, 224, 0.6)'},
    {f: 'rgba(181, 3, 154, 1)', b: 'rgba(181, 3, 154, 0.6)'}
  ];
  @ViewChildren('valSpan') spans: QueryList<any>;
  @ViewChildren('valDiv') divs: QueryList<any>;
  @Input() Total: number;
  @Input() Title: string;
  @Input() Format: string;
  @Input() ValueInTooltip: boolean;
  @Input()  set data(value: ExcIndicatorData[]) {
    this._data = value;
    this.sum = 0;
    for (let i = 0; i < this._data.length; i++) {
      this.sum += this._data[i].Value;
      if (this._data[i].BackgroundColor === null) {
        this._data[i].BackgroundColor = this._colors[i % this._colors.length].b;
      }
    }
  }
  get data() {
    return this._data;
  }
  constructor(private datePipe: DatePipe, private excCurrency: ExcCurrency, private changeDetectorRef: ChangeDetectorRef, private excDss: DefaultSettingsService) {
    super();
    this.Format = this.Format || null;
    this.ValueInTooltip = this.ValueInTooltip || false;
  }
  getStyle(o) {
    let total = 0;
    if (this.Total) {
      total = this.Total;
    } else {
      total = this.sum;
      for (const a of this._data) {
        if (a.IsPrimary === true) {
          total = a.Value;
          break;
        }
      }
    }
    let x = o.Value / total * 100;
    x = Math.fround(Math.abs(x));
    if (x > 100) {
      x = 100;
    }
    o.divWidth = x;

    if (o.BorderColor !== null) {
      return {width:  'calc(' + x + '% - 0.5rem)'
        , marginLeft: 'calc(100% - ' + x + '%)'
        , padding: (o.Value === 0 ? '0' : '0 0.25rem 0 0.25rem')
        , lineHeight: '1.5rem'
        , minHeight: '1.5rem'
        , borderRadius: '4px 0 0 4px'
        , float: 'left'
        , backgroundColor: o.BackgroundColor
        , visibility: o.Value === 0 ? 'hidden' : 'visible', cursor: 'default'};
    }
    return {width: (o.IsPrimary === true ? '100' : x) + '%'
      , visibility: o.Value === 0 ? 'hidden' : 'visible', cursor: 'default'};
  }
  getText(o) {
    if (this.Format === null) {
      return o.Value;
    }
    if (this.Format === 'date') {
      return this.datePipe.transform(o.Value, this.getGlobal('FormatDate'));
    }
    if (this.Format === 'currency') {
      return this.excCurrency.transform(o.Value);
    }
  }

  getSpanStyle(barDiv) {

    const barWidth = barDiv.offsetWidth;
    const labelWidth = barDiv.children[0].offsetWidth;
    if (labelWidth > (barWidth - 8)) {
      return {
          marginLeft: '-' + (labelWidth + 8) + 'px'
          // , color: '#000'
        , float: 'right'
      };
    }
    return {
      // color: '#fff',
       float: 'right'
    };
  }
  ngAfterViewChecked(): void {
    this.changeDetectorRef.detectChanges();
  }

  ngOnInit() {
  }
}
export class ExcIndicatorData {
  Value: number ;
  Text: string;
  Tooltip: string = null;
  BackgroundColor: string = null;
  IsPrimary = false;
  DivWidth = 0;
  SpanWidth = 0;
  constructor(Value, Text, Tooltip?, BackgroundColor?, IsPrimary?) {
    this.Value = Value;
    this.Text = Text;
    this.Tooltip = Tooltip;
    this.IsPrimary = IsPrimary || false;
    this.BackgroundColor = BackgroundColor || null;
  }
}
